import React, { useState } from 'react';
import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Divider,
  Flex,
  PrimaryButton,
  RemoteImage,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import { TextInput, View } from 'react-native';
import { localizeNumber } from 'shared/src/utils';

type ReportPriceAbusingParams = {
  goodsImage: string;
  marketName: string;
  goodsName: string;
  discountRate: number;
  price: number;
};

export const useReportPriceAbusingBottomSheet = createUseBottomSheetModal<
  { comments: string },
  ReportPriceAbusingParams
>(({ param, confirm }) => {
  const [comments, setComments] = useState('');

  return (
    <BottomSheetContainer>
      <Flex padding={{ horizontal: 20, top: 20, bottom: 20 }}>
        <Typography type={'subtitle1'}>이상 판매가 제보</Typography>
        <VerticalSpacing size={12} />
        <Typography type={'body2'} color={'content_secondary'}>
          {'표시된 가격이 실제 구매 가격과 다르거나\n오해의 소지가 있는 경우 제보해 주세요.'}
        </Typography>
        <VerticalSpacing size={4} />
        <Typography type={'body3'} color={'content_tertiary'}>
          예시 : 의도적으로 낮은 가격으로 설정한 경우 등
        </Typography>
        <VerticalSpacing size={20} />
        <Divider size={'small'} />
        <VerticalSpacing size={20} />
        <Flex.Row gap={12} alignItems={'center'}>
          <View style={{ borderRadius: 8, overflow: 'hidden' }}>
            <RemoteImage uri={param.goodsImage} width={56} height={56} />
          </View>
          <Flex flex={1} gap={4}>
            <Typography
              type={'body3'}
              color={'content_tertiary'}
              numberOfLines={1}
            >
              {param.marketName}
            </Typography>
            <Typography type={'body2'} numberOfLines={1}>
              {param.goodsName}
            </Typography>
            <Flex.Row gap={4} alignItems={'center'}>
              {param.discountRate > 0 && (
                <Typography type={'subtitle3'} color={'content_pink_primary'}>
                  {param.discountRate}%
                </Typography>
              )}
              <Typography type={'subtitle3'}>
                {localizeNumber(param.price)}원
              </Typography>
            </Flex.Row>
          </Flex>
        </Flex.Row>
        <VerticalSpacing size={20} />
        <TextInput
          maxLength={800}
          placeholder="내용을 입력해 주세요 (선택)"
          placeholderTextColor={Colors.content_tertiary}
          value={comments}
          onChangeText={setComments}
          multiline
          style={{
            height: 120,
            textAlignVertical: 'top',
            borderWidth: 1,
            borderColor: Colors.border_primary,
            borderRadius: 8,
            padding: 12,
            fontSize: 14,
          }}
        />
        <VerticalSpacing size={4} />
        <Flex.Row justifyContent={'flex-end'}>
          <Typography type={'body4'} color={'content_tertiary'}>
            {comments.length}/800
          </Typography>
        </Flex.Row>
        <VerticalSpacing size={20} />
        <PrimaryButton
          variant={'fill'}
          size={'xlarge'}
          onPress={() => confirm({ comments })}
        >
          제보하기
        </PrimaryButton>
      </Flex>
    </BottomSheetContainer>
  );
});
